import styled from 'styled-components';

interface IProps {
  variant?: 'filled' | 'outlined' | 'none';
  width?: number;
}

const TextField = styled.input<IProps>`
  ${({ variant, width }) => {
    switch (variant) {
      case 'filled':
        return `
          padding: 0 0 0 20px;
          width: 100%;
          height: 38px;
          line-height: 38px;
          background: #fff;
          border: 1px solid #ddd;
        `;
      case 'outlined':
        return `
          width: ${width ? width : '200'}px;
          padding: 5px 8px;
          border: 1px solid #e2e2e2;
          background: none;
          border-radius: 3px;
        `;
      case 'none':
        return `
          display: none;
        `;
      default:
        return `
          width: 100%;
          padding-bottom: 5px;
          border: none;
          background: none;
          border-bottom: 1px solid #ddd;
        `;
    }
  }}
`;

export default TextField;
